export interface IFollow {
  name: string;
  status: string;
  thumb: string;
  large: string;
  id: number;
}

const data: IFollow[] = [
  {
    name: 'Mayra Sibley',
    status: 'Lack of Humility',
    thumb: '/assets/img/profiles/l-5.jpg',
    large: '/assets/img/profiles/5.jpg',
    id: 1
  },
  {
    name: 'Philip Nelms',
    status: 'Lead Developer',
    thumb: '/assets/img/profiles/l-2.jpg',
    large: '/assets/img/profiles/2.jpg',
    id: 2
  },
  {
    name: 'Kathryn Mengel',
    status: 'Dog & Cat Person',
    thumb: '/assets/img/profiles/l-10.jpg',
    large: '/assets/img/profiles/10.jpg',
    id: 3
  },
  {
    name: 'Esperanza Lodge',
    status: 'Now giving divorce advices!',
    thumb: '/assets/img/profiles/l-4.jpg',
    large: '/assets/img/profiles/4.jpg',
    id: 4
  },
  {
    name: 'Ken Ballweg',
    status: 'Hi there, I am using Vien!',
    thumb: '/assets/img/profiles/l-3.jpg',
    large: '/assets/img/profiles/3.jpg',
    id: 5
  },
  {
    name: 'Rasheeda Vaquera',
    status: '...',
    thumb: '/assets/img/profiles/l-6.jpg',
    large: '/assets/img/profiles/6.jpg',
    id: 6
  },
  {
    name: 'Linn Ronning',
    status: 'What goes around comes around',
    thumb: '/assets/img/profiles/l-7.jpg',
    large: '/assets/img/profiles/7.jpg',
    id: 7
  },
  {
    name: 'Marty Otte',
    status: 'Big city life',
    thumb: '/assets/img/profiles/l-9.jpg',
    large: '/assets/img/profiles/9.jpg',
    id: 8
  },
  {
    name: 'Laree Munsch',
    status: 'New Job  :)',
    thumb: '/assets/img/profiles/l-11.jpg',
    large: '/assets/img/profiles/11.jpg',
    id: 9
  }
];

export default data;
